import { render, staticRenderFns } from "./BatchModifyShortTitle.vue?vue&type=template&id=51704162&scoped=true"
import script from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
export * from "./BatchModifyShortTitle.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyShortTitle.vue?vue&type=style&index=0&id=51704162&prod&scoped=true&lang=css"
import style1 from "./BatchModifyShortTitle.vue?vue&type=style&index=1&id=51704162&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51704162",
  null
  
)

export default component.exports